export default class RepresentacaoConjunto {
  constructor(data = null) {
    if (data) {
      this.id = data.id;
      this.idGrupoFornecedor = data.idGrupoFornecedor;
      this.qtdGruposAtivos = data.qtdGruposAtivos;
      this.qtdGruposAtivosSuspensos = data.qtdGruposAtivosSuspensos;
      this.listaGrupos = data.listaGrupos;
      this.indAtivo = data.indAtivo;
    } else {
      this.id = null;
      this.qtdGruposAtivos = 0;
      this.qtdGruposAtivosSuspensos = 0;
      this.listaGrupos = [];
      this.indAtivo = true;
    }
  }

  construirAPartirDaConsultaCompleta(dadosDaConsulta) {
    this.id = dadosDaConsulta.id;
    this.idGrupoFornecedor = dadosDaConsulta.idGrupoFornecedor;
    this.qtdGruposAtivos = dadosDaConsulta.qtdGruposAtivos;
    this.qtdGruposAtivosSuspensos = dadosDaConsulta.qtdGruposAtivosSuspensos;
    this.listaGrupos = dadosDaConsulta.listaGrupos;
    this.indAtivo = dadosDaConsulta.indAtivo;
  }

  ehEdicao() {
    return this.id;
  }
}
